// src/FingerprintScanner.js
import React, { useState } from "react";
import { Box, Button, Typography, CircularProgress, Paper } from "@mui/material";

function FingerprintScanner() {
    const [fingerprint, setFingerprint] = useState("");
    const [scanning, setScanning] = useState(false);
    const scanFinger = async () => {
        if (!window.biometric) {
            alert("Please run this as a Desktop App");
            return;
        }

        setScanning(true);
        setFingerprint("");

        try {
            // Just call it once and handle the result
            const result = await window.biometric.scanFingerprint();

            if (result.success) {
                setFingerprint(result.template);
            } else {
                alert("Scanner Error: " + result.error);
            }
        } catch (err) {
            alert("System Error: Check USB connection.");
        } finally {
            setScanning(false);
        }
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            bgcolor="#fdf2f2"
            p={3}
        >
            <Paper sx={{ p: 4, borderRadius: 3, maxWidth: 500, width: "100%" }}>
                <Typography variant="h5" mb={3} textAlign="center" fontWeight="bold">
                    Fingerprint Scanner
                </Typography>

                <Button
                    variant="contained"
                    color="error"
                    fullWidth
                    onClick={scanFinger}
                    disabled={scanning}
                >
                    {scanning ? "Scanning..." : "Scan Finger"}
                </Button>

                {scanning && <CircularProgress sx={{ mt: 2 }} />}

                {fingerprint && (
                    <Typography mt={3} variant="body1">
                        Fingerprint Template: <b>{fingerprint}</b>
                    </Typography>
                )}
            </Paper>
        </Box>
    );
}

export default FingerprintScanner;